<!--
 * @Date: 2022-04-07 10:00:16
 * @Author: 陶子
 * @LastEditTime: 2022-04-07 10:20:03
 * @FilePath: \jk_one-stop_cloud_mobile_v1.0\src\views\mine\consult.vue
 * @pageName: 这是--(业务咨询)--页面
-->
<template>
  <div>
    <Navbar :appTitle="$route.meta.title" />
    <div class="itemBox">
      <img src="~@/assets/img/dianhua.png" alt="" class="itemLeft">
      <div class="itemRight">
        <div class="rightTop">客服热线</div>
        <div class="rightBot">400-718-9668</div>
      </div>
    </div>
    <div class="itemBox">
      <img src="~@/assets/img/calendar.png" alt="" class="itemLeft">
      <div class="itemRight">
        <div class="rightTop">服务时间</div>
        <div class="rightBot">周一至周五 09:00~18:00</div>
      </div>
    </div>
    <div class="lastBox">安徽来睿科技有限公司提供技术支持</div>
  </div>
</template>

<script>
import Navbar from "@/components/navBar/navBar_right";
export default {
  components: { Navbar },
  props: [],
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang='less'>
.flex(@jc,@ai,@fd:row) {
  display: flex;
  justify-content: @jc;
  align-items: @ai;
  flex-direction: @fd;
}
div.itemBox {
  .flex(flex-start,flex-start);
  box-sizing: border-box;
  padding: 0.15rem 0.16rem 0.18rem;
  background: #ffffff;
  margin-top: 0.1rem;
  img.itemLeft {
    width: 0.15rem;
    height: 0.15rem;
    margin-right: 0.12rem;
    position: relative;
    top: 0.02rem;
  }

  div.itemRight {
    div.rightTop {
      font-size: 0.14rem;
      color: rgba(25, 31, 37, 0.8);
    }

    div.rightBot {
      font-size: 0.16rem;
      font-weight: 500;
      color: #191f25;
      margin-top: 0.16rem;
    }
  }
}
.lastBox {
  font-size: 0.11rem;
  color: #888888;
  margin-top: 0.25rem;
  text-align: center;
}
</style>
